import { PageGeneral } from "types/CMS/KontentAI/content-types";

export const urlHierarchyTraversal = (
  page?: PageGeneral,
  depth: number = 0,
  maxDepth: number = 3,
  urlPath: string[] = []
): string[] => {
  if (!page || depth > maxDepth) return urlPath;
  const { url_slug, parent_page } = page.elements;
  const urlSlug = url_slug.value;
  const newPath = [urlSlug, ...urlPath];
  const parentPage = parent_page?.linkedItems?.[0];
  if (!parentPage) return newPath;

  return urlHierarchyTraversal(parentPage, depth + 1, maxDepth, newPath);
};
